import { render, staticRenderFns } from "./chip-secondary.vue?vue&type=template&id=6f77496a&scoped=true&"
import script from "./chip-secondary.vue?vue&type=script&lang=js&"
export * from "./chip-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77496a",
  null
  
)

export default component.exports